// @ts-nocheck

import CommonApi from '../commonApi';
import { fetchRequest, initialFetchListParams } from './index';
const baseUrl = 'bioTreatmentFacilityFact';
const bioTreatmentFacilityFact = new CommonApi(baseUrl, 'учет БОС факт');
const list = async (params = initialFetchListParams) => {
  const list = await fetchRequest.get(`/${baseUrl}/listAccountingBos`, {
    ...initialFetchListParams,
    ...params
  });
  if (list) {
    return list;
  }
  throw new Error('Не удалось получить список');
};
const assign = async bioTreatmentFacilityFact => {
  const fact = await fetchRequest.post(`/${baseUrl}/assign`, bioTreatmentFacilityFact);
  if (fact) {
    return fact;
  }
  throw new Error('Не удалось обновить талон');
};
const addToVolume = async (bioTreatmentFacilityFact, volumeId) => {
  const fact = await fetchRequest.post(`/${baseUrl}/addToVolume/${volumeId}`, bioTreatmentFacilityFact);
  if (fact) {
    return fact;
  }
  throw new Error('Не удалось создать факт');
};
const changeStatus = async bioTreatmentFacilityFact => {
  const list = await fetchRequest.put(`/${baseUrl}/changeStatus`, bioTreatmentFacilityFact);
  if (list) {
    return list;
  }
  throw new Error('Не удалось получить список');
};
export default {
  ...bioTreatmentFacilityFact,
  list,
  changeStatus,
  assign,
  addToVolume
};
